import React from 'react'
import './pagenotfound.css'
import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import img2 from "../Login/img/logo2.png"

const Pagenotfound = () => {
  return (
    <>
      <ToastContainer position="top-center" />
      <div className='notfound-layout'>
        <div className='d-flex justify-content-center align-items-center mt-4'>
          <img  className="img-fluid logo" src={img2}  />
        </div>
        <div id="notfound">
          <div class="notfound">
            <div class="notfound-404">
              <h1>404</h1>
            </div>
            <h2 className=''>Oops! This Page Could Not Be Found</h2>
            <p className='mt-3'>Sorry but the page you are looking for does not exist, have been removed. name changed or is temporarily unavailable</p>
            <Link to="/dashboard">Go To Homepage</Link>
          </div>
        </div>
      </div>
    </>

  )
}

export default Pagenotfound